export const badgeProps = {
  shadow: {
    type: Boolean
  },
  color: {
    type: String
  }
}
